import { BowlIcon, JarIcon, OthersIcon } from "../../../utils/iconRefs/recipeStepsIcons"
import { LocationEnum } from "./constants"


const LocationIcon = ({ location }: { location: string }) => {
  if (location.toLowerCase() === LocationEnum.JAR) {
    return <JarIcon />
  }
  else if (location.toLowerCase() === LocationEnum.BOWL) {
    return <BowlIcon />
  }
  else {
    return <OthersIcon />
  }
}

export default LocationIcon